import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../utils/api';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get token from URL query param
        const token = searchParams.get('token');
        const error = searchParams.get('error');

        if (error) {
          console.error('OAuth error:', error);
          navigate('/login?error=' + error, { replace: true });
          return;
        }

        if (!token) {
          console.error('No token in URL');
          navigate('/login', { replace: true });
          return;
        }

        // Store token and fetch user data
        localStorage.setItem('token', token);
        
        // Fetch user data with the token
        const response = await authAPI.me();
        
        if (response.data) {
          loginWithToken(token, response.data);
          
          // Check if there's a guest form draft to import
          const savedForm = localStorage.getItem('guest_form_draft');
          if (savedForm) {
            try {
              const parsed = JSON.parse(savedForm);
              if (parsed.fields && parsed.fields.length > 0) {
                localStorage.setItem('create_form_from_draft', 'true');
                navigate('/dashboard?import_draft=true', { replace: true });
                return;
              }
            } catch (e) {}
          }
          navigate('/dashboard', { replace: true });
        } else {
          throw new Error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        localStorage.removeItem('token');
        navigate('/login?error=auth_failed', { replace: true });
      }
    };

    processAuth();
  }, [navigate, searchParams, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
